import React, { useEffect, useState, createRef, useRef } from 'react';
import { ChatThreadClient } from '@azure/communication-chat';
import { useSelector } from 'react-redux';
import pubsub from 'pubsub-js';
import moment from 'moment';
import Component from '../../assets/Component 1.png';
import {
  chatAreaContainerStyle,
  MessageBarStyle,
  mRightStyle,
  ExpressionBoxStyle,
  emojiItemStyle,
  inputIcon
} from '../styles/StartScreen/ChatArea.styles';
import {
  sendBoxStyle,
  sendIconStyle,
  textFieldStyle,
  TextFieldStyleProps,
  sendBox,
  scrollToBottom as scrollToBottomStyles,
  boxStyle,
  PromptText,
  TransferCard
} from '../styles/StartScreen/SendBox.styles';

import {
  Stack,
  TextField,
  Text,
  Icon,
  ITextField,
  TeachingBubble,
  ITeachingBubbleStyles,
  DirectionalHint,
  Dialog,
  DialogType,
  PrimaryButton,
  DialogFooter
} from '@fluentui/react';
import { Chat, Avatar, AcceptIcon, Flex, Ref, Divider, Image } from '@fluentui/react-northstar';
import { ChatMessageItem } from '../../models/ChatStores';
import { apiServices } from '../../services/ApiServices';
import { ENTER_KEY, MAXIMUM_LENGTH_OF_MESSAGE } from '../../constants';
import CloseListDialog from './CloseListDialog';
import { ContextualMenu } from '@fluentui/react/lib/ContextualMenu';
import TransferListDialog from './TransferListDialog';
import { getExpression, setExpression } from '../../utils/utils';
import { v4 as uuidv4 } from 'uuid';
import DOMPurify from 'isomorphic-dompurify';

import { analytics } from '../../utils/analytics';
import getAuthUser from '../../selectors/getAuthUser';
import { getLastMessage } from '../../helpers/getLastMessage';
import { getSecondsSinceMessage } from '../../helpers/getSecondsSinceMessage';
import { onImageLoadSuccess, onImageLoadError } from './imageUtils';

interface ChatAreaProps {
  isScroll: Boolean;
  threadClient: ChatThreadClient;
  threadId: string;
  user: string;
  isInvolved: boolean;
  avatar: string;
  customerId: string;
  appId: string;
  ticketId: string;
  displayTicketId: string;
  fromUserExtend: any;

  handleRemove(threadId: string, isTransfer?: boolean, isToMe?: boolean): void;
}

// global reference to the internal chat message. 
// This is used for analytics purposes only, and needed
// as its consumed in an pubsub callback, which has no 
// reference to the component.
var chatMessagesRef: any = createRef();

const teachingBubbleStyle: Partial<ITeachingBubbleStyles> = {
  body: { backgroundColor: '#fff' },
  bodyContent: { backgroundColor: '#fff', padding: '0px' },
  root: { backgroundColor: '#fff', '.ms-Callout-beak': { backgroundColor: '#fff' } },
  footer: {
    backgroundColor: '#fff',
    [`& > .ms-StackItem`]: {
      backgroundColor: '#fff',
      display: 'flex',
      flexDirection: 'row-reverse'
    },
    [`& > .ms-StackItem > .ms-Button:not(:first-child)`]: {
      backgroundColor: '#fff',
      margin: '0 15px 0 0'
    }
  }
};
const dialogStyles = {
  main: { maxWidth: 450, width: '400px', borderRadius: '4px' },
  scrollableContent: { width: '400px' }
};
const dragOptions = {
  moveMenuItemText: 'Move',
  closeMenuItemText: 'Close',
  menu: ContextualMenu
};
let receiveMessage: NodeJS.Timeout;
export default (props: ChatAreaProps): JSX.Element => {
  const createdRef: any = createRef();
  const messagesEnd = useRef<HTMLDivElement>(null);
  const inputRef = useRef<ITextField>(null);
  const [closeDialogToggle, setCloseDialogToggle] = useState(false);
  const [closeDialogInitial, setCloseDialogInitial] = useState(true);
  const [transferDialogToggle, setTransferDialogToggle] = useState(false);
  const [transferDialogInitial, setTransferDialogInitial] = useState(true);
  const [HintDialogTitle, setHintDialogTitle] = useState('');
  const [HintDialogSubText, setHintDialogSubText] = useState('');
  const [hideDialog, setHideDialog] = useState(false);
  const [isToMe, setIsToMe] = useState(true); //是否为自己转单
  const [hideDialogStatus, setHideDialogStatus] = useState(0); //转单状态码  0 失败 1 转单成功 2 关单成功
  const [isDraggable, setIsDraggable] = useState(false);
  const modalProps = React.useMemo(
    () => ({
      // titleAriaId: labelId,
      // subtitleAriaId: subTextId,
      isBlocking: true,
      styles: dialogStyles,
      dragOptions: isDraggable ? dragOptions : undefined
    }),
    [isDraggable]
  );

  const [isShowbar, setIsShowbar] = useState(true);
  const [massageState, setMassageState] = useState([
    {
      color: 'red',
      Icon: 'InfoSolid',
      title: '发送失败,点击重新发送'
    },
    {
      color: 'green',
      Icon: 'SkypeCircleCheck',
      title: '发送成功'
    },
    {
      color: '',
      Icon: 'ProgressRingDots',
      title: '发送中...'
    },
    {
      color: 'orange',
      Icon: 'InfoSolid',
      title: '发送失败,非当前单消息,无法重发'
    }
  ]);
  const [textValue, setTextValue] = useState('');
  const [loadText, setLoadText] = useState('加载更多历史消息');
  const [textValueOverflow, setTextValueOverflow] = useState(true);
  const [chatMessages, setChatMessages] = useState<ChatMessageItem[]>([]);
  const [showDialog, setShowdialog] = useState(false);
  const [isShowToBottomTip, setIsShowToBottomTip] = useState(false);
  const [UserName, setUserName] = useState(JSON.parse(sessionStorage.getItem('user') || '')?.displayName);
  const [avatarUrl, setAvatarUrl] = useState(JSON.parse(sessionStorage.getItem('user') || '')?.avatar);
  const [ussID, setUssID] = useState('');
  const [toBottomTip, setToBottomTip] = useState('返回底部');
  const [emojiArr, setEmojiArr] = useState([
    { key: '/::)', value: '🙂' },
    { key: '/::~', value: '😔' },
    { key: '/::B', value: '😍' },
    { key: '/::>', value: '😀' },
    { key: '/::|', value: '😶' },
    { key: '/:8-)', value: '😎' },
    { key: '/::<', value: '😭' },
    { key: '/::X', value: '😷' },
    { key: '/::Z', value: '😴' },
    { key: '/::-|', value: '🥵' },
    { key: '/::@', value: '😡' },
    { key: '/::D', value: '😁' },
    { key: '/::O', value: '😮' },
    { key: '/::(', value: '🙁' },
    { key: '/:--b', value: '😳' },
    { key: '/::Q', value: '😣' },
    { key: '/::T', value: '🤢' },
    { key: '/:,@P', value: '🤭' },
    { key: '/:,@-D', value: '😊' },
    { key: '/::d', value: '🙄' },
    { key: '/:,@o', value: '😕' },
    { key: '/:|-)', value: '😌' },
    { key: '/::!', value: '😰' },
    { key: '/::-S', value: '🤬' },
    { key: '/:?', value: '🤨' },
    { key: '/:,@x', value: '🤫' },
    { key: '/:,@@', value: '😵' },
  ]);

  // Use the auth user id in some analytics events to help us
  // report the individual number of messages sent/received/failed by each agent.
  const authUser = useSelector(getAuthUser);

  useEffect( () => {
    chatMessagesRef.current = chatMessages;
  }, [chatMessages]);

  const addMessage = (msgType: number, defaultText?: string, MediaId?: string) => {
    setTimeout(() => {
      let messageId = uuidv4();
      //发送消息
      if (textValueOverflow && (textValue || defaultText)) {
        //避免多次回车可以多次发送消息，回车后清空输入框内容
        let txt = '';
        if (!defaultText) {
          textValue.lastIndexOf('\n') !== -1 && textValue.lastIndexOf('\n') == textValue.length - 1
            ? (txt = setExpression(textValue.substring(0, textValue.lastIndexOf('\n'))))
            : (txt = setExpression(textValue));
        } else {
          txt = defaultText;
        }

        const sanitizedText = DOMPurify.sanitize(txt)
        setTextValue('');
        let msgData = {
          id: messageId,
          localId: messageId,
          avatar: avatarUrl,
          body: {
            MsgType: msgType,
            Content: sanitizedText,
            Url: defaultText
          },
          userid: '',
          username: UserName,
          mine: 'support',
          date: moment(new Date()).format('YYYY/MM/DD LT'),
          status: 2
        };
        let newChatMessages = JSON.parse(JSON.stringify(chatMessages));
        newChatMessages.push(msgData);
        setChatMessages(() => {
          return newChatMessages;
        });
        scrollToBottom();

        let resData: any = {};
        if (msgType === 0) {
          resData = {
            threadId: props.threadId,
            text: sanitizedText,
            MessageType: msgType
          };
        } else {
          resData = {
            threadId: props.threadId,
            MediaId: MediaId,
            url: defaultText,
            MessageType: msgType
          };
        }

        // track attempt to send message
        const lastMessage = getLastMessage(chatMessages);
        analytics.trackEvent('add_message_begin', {
          messageType: msgType,
          userId: authUser?.userId,
          userName: authUser?.name,
          lastMessageMine: lastMessage?.mine,
          lastMessageUserId: lastMessage?.userid,
          secondsSinceLastMessage: getSecondsSinceMessage(lastMessage),
          threadId: resData?.threadId,
          messageContent: resData?.text
        });

        apiServices
          .postMessageToWechat(resData, {
            userId: authUser?.userId,
            userName: authUser?.name,
            threadId: resData?.threadId
          })
          .then((res) => {
            analytics.trackEvent('add_message_success', {
              messageType: msgType,
              userId: authUser?.userId,
              userName: authUser?.name,
              result: res?.result,
              threadId: resData?.threadId    
            });

            if (res.result) {
              setChatMessages((s: any) => {
                const content = JSON.parse(res.result.content);
                for (let i = 0; i < s.length; i++) {
                  if (s[i].localId && s[i].localId === messageId) {
                    s[i] = {
                      id: res.result.id,
                      localId: messageId,
                      avatar: avatarUrl,
                      body: content,
                      userid: content.ChannelId,
                      username: UserName,
                      mine: 'support',
                      date: moment(content.Timestamp).format('YYYY/MM/DD LT'),
                      status: res.status === 0 ? 1 : 0
                    };
                  }
                }

                return s;
              });

              // acs向其他参与聊天客服同步消息
              if (res.status == 0) {
                props.threadClient
                  ?.sendMessage(
                    {
                      content: JSON.stringify(msgData.body)
                    },
                    {
                      senderDisplayName: `support,${UserName},${avatarUrl},${messageId}`
                    }
                  )
                  .then((res) => {
                    // console.log( "acs消息发送成功：",res);
                  });
              } else {
                let e = {
                  senderDisplayName: '45C218B5-0CF1-4703-8272-4E863528A1E7',
                  mine: '45C218B5-0CF1-4703-8272-4E863528A1E7',
                  threadId: props.threadId,
                  message: JSON.stringify({ content: res.errorMessage }),
                  id: '45C218B5-0CF1-4703-8272-4E863528A1E7'
                };
                pubsub.publish(`message-${e.threadId}`, e);
              }
            }
          })
          .catch((error) => {
            analytics.trackEvent('add_message_error', {
              messageType: msgType,
              userId: authUser?.userId,
              userName: authUser?.name,
              error
            });

            const updatedMessages = newChatMessages.map((item: any) => {
              // update the failed message status
              if (item.id === messageId) {
                return {
                  ...item,
                  id: 'result.id',
                  avatar: avatarUrl,
                  body: {
                    MsgType: 0,
                    Content: txt
                  },
                  userid: 'content.ChannelId',
                  username: UserName,
                  mine: 'support',
                  date: moment(new Date()).format('YYYY/MM/DD LT'),
                  status: 0
                };
              }

              return item;
            });
            
            setChatMessages(updatedMessages);
          });
      }
    }, 0);
  };

  const ResendMassage = (message: ChatMessageItem) => {
    if (message.status === 0) {
      let newChatMessages = JSON.parse(JSON.stringify(chatMessages));
      const index = newChatMessages.findIndex((item: any) => item.id === message.id);
      let Resenddata = newChatMessages.splice(index, 1)[0];
      Resenddata.date = moment(new Date()).format('YYYY/MM/DD LT');
      Resenddata.status = 2;
      newChatMessages.push(Resenddata);
      setChatMessages((s) => {
        return [...newChatMessages];
      });
      scrollToBottom();
      apiServices.sendretryMessage({ threadId: props.threadId, id: message.id }).then((res) => {
        const result = res.result;
        if (res.status === 0) {
          const content = JSON.parse(res.result.content);
          newChatMessages[newChatMessages.length - 1] = {
            id: result.id,
            avatar: avatarUrl,
            body: message.body,
            userid: content.ChannelId,
            username: UserName,
            mine: 'support',
            date: moment(result.clientArrivalTime).format('YYYY/MM/DD LT'),
            status: res.status == 0 ? 1 : 0
          };
          newChatMessages[newChatMessages.length - 1].status = 1;
        } else {
          let e = {
            senderDisplayName: '45C218B5-0CF1-4703-8272-4E863528A1E7',
            mine: '45C218B5-0CF1-4703-8272-4E863528A1E7',
            threadId: props.threadId,
            message: JSON.stringify({ content: res.errorMessage }),
            id: '45C218B5-0CF1-4703-8272-4E863528A1E7'
          };
          pubsub.publish(`message-${e.threadId}`, e);
          newChatMessages[newChatMessages.length - 1].status = 0;
        }

        setChatMessages((s) => {
          return [...newChatMessages];
        });
      });
    }
  };
  const setText = (e: any) => {
    let str = e.target.value;
    str.substring(0, str.lastIndexOf('\n'));

    if (str.length > MAXIMUM_LENGTH_OF_MESSAGE || !str) {
      //输入内容最大长度8000
      setTextValueOverflow(false);
    } else {
      setTextValueOverflow(true);
    }
    setTextValue(str);
  };

  const closeChat = async () => {
    //关闭工单
    //出遮罩 弹框
    setCloseDialogToggle(!closeDialogToggle);
    setCloseDialogInitial(false);
  };
  //转交工单
  const TransferChat = async () => {
    //转交工单
    //出遮罩 弹框
    setTransferDialogToggle(!transferDialogToggle);
    setTransferDialogInitial(false);
  };
  const hideDialogPrimary = async () => {
    setHideDialog(true);
    setHintDialogSubText('');
    setHintDialogTitle('');
    if (hideDialogStatus === 1) {
      sessionStorage.setItem('activeThreads', props.threadId);
      props.handleRemove(props.threadId, true, isToMe); //删除侧边连聊天列表该用户信息
    } else if (hideDialogStatus === 2) {
      props.handleRemove(props.threadId); //删除侧边连聊天列表该用户信息
    }
  };
  const closeComment = async (data: any, text: string, isToMe: boolean) => {
    setHideDialogStatus(0);
    let data2 = {
      ticketId: props.ticketId,
      agentId: data.data.userId,
      comment: text
    };
    let res = await apiServices.transferTicket(data2);
    setIsToMe(isToMe);
    if (res.status === 0) {
      setHintDialogSubText(`转交成功`);
      setHintDialogTitle('转交工单');
      setHideDialogStatus(1); // 转单成功状态码
      setHideDialog(false);
    } else {
      setHintDialogTitle('转交工单');
      setHintDialogSubText(`${res.errorMessage}`);
      setHideDialog(false);
    }
  };
  const EndComment = async (text: string) => {
    setHideDialogStatus(0);
    //关闭工单确定按钮
    let res = await apiServices.postEndChat({
      ChatThreadId: props.threadId,
      Comment: text
    });
    if (res && !res.errorMessage) {
      setHideDialogStatus(2); // 关单成功状态码
      setIsShowbar(false);
      sessionStorage.setItem('activeThreads', props.threadId);
    } else {
      setHintDialogTitle('关闭工单');
      setHintDialogSubText(`${res.errorMessage}`);
      setHideDialog(false);
    }
  };

  const handleExpression = async () => {
    //表情包弹框
    setShowdialog(!showDialog);
  };
  const sendFiles = async () => {
    // additional tracking data, used internally for reporting
    const analyticsData = {
      userId: authUser?.userId,
      userName: authUser?.name
    }

    analytics.trackEvent('send_files_begin', {
      ...analyticsData
    });
    
    //上传文件
    let inputs = document.createElement('input');
    inputs.accept = 'image/*';
    inputs.setAttribute('type', 'file');
    inputs.type = 'file';

    inputs.onchange = async (ev: Event) => {
      let tenantId: any = sessionStorage.getItem('user');
      tenantId = JSON.parse(tenantId).tenantId;
      if (inputs && inputs.files) {
        var File = inputs.files[0];
        if (File.size < 1048576) {
          let data = new FormData();
          data.append('file', File);
          let response = await apiServices.uploadfiletowehatandblob(tenantId, props.appId, data, analyticsData)

          const addMessageWhenIfReady = (response: any) => {
            if(response?.result?.length > 0) {
              analytics.trackEvent('send_files_success', {
                ...analyticsData,
                fileBlobUrl: response?.result[0].fileBlobUrl
              });

              addMessage(1, response?.result[0].fileBlobUrl, response?.result[0].fileWechatMediaId);
            } else {
              analytics.trackEvent('send_files_error', {
                ...analyticsData,
                error: response
              });
           }
          }

          if(response?.result?.length > 0) {
            addMessage(1, response?.result[0].fileBlobUrl, response?.result[0].fileWechatMediaId);
          }
          else {
            // Azure blob storage might return a 200ok, even though the conten is not "ready".
            // If so, delay adding the message until its fully processed.
            setTimeout( () => addMessageWhenIfReady(response), 500 );
          }
        } else {
          // file is too large
          analytics.trackEvent('send_files_error', {
            ...analyticsData,
            error: 'file is too large'
          });
          alert('图片超过1M');
        }
      }
    };
    inputs.click();
  };

  const sendEmoji = (value: string) => {
    //表情转码
    setTextValue(getExpression(textValue) + getExpression(value));
    analytics.trackEvent('send_emoji', {
      value
    })
    setShowdialog(false);
  };

  //返回底部效果
  const onScrollHandler = () => {
    setIsShowToBottomTip(canScrollToBottom());
  };

  const canScrollToBottom = () => {
    const chatHeight = createdRef?.current?.firstChild?.clientHeight;
    const scrollHeight = createdRef?.current?.firstChild?.scrollHeight;
    const scrollTop = createdRef?.current?.firstChild?.scrollTop;

    return Math.ceil(scrollTop) < Math.ceil(scrollHeight - chatHeight);
  }

  const scrollToBottom = () => {
    createdRef?.current?.firstChild?.scroll({
      behavior: 'smooth', // 平滑移动

      // use a really high value to scroll to the end without having to do any math 
      // in order to calculate precisely by how many pixels should we scroll
      top: 999999 
    });
  };
  const LoadHistoryMessages = async (Timestamp: string, lint: number, isReverse: Boolean) => {
    let Timestamp2 = moment(Timestamp).utc().format().replace('+', '%2B');
    //加载历史记录
    let res = await apiServices.getHistoricalDialogue(props.appId, props.customerId, Timestamp2, lint);
    let agentlist = await apiServices.listAgent();
    let result = res.result;
    result.map((item: any) => {
      if (item.messageType === 'Text' || item.messageType === 'Image') {
        item.content = JSON.parse(item.content);
      }
    });

    result = result
      .map((x: any) => ({
        id: x.id,
        avatar: x.content.ChannelUserId === null ? '' : props.avatar,
        body: x.content,
        userid: x.receiver,
        creator: x.creator,
        username: x.senderDisplayName,
        mine:
          x.messageType !== 'Text' && x.messageType !== 'Image'
            ? x.messageType
            : x.content.ChannelUserId === null
              ? 'support'
              : '',
        date: x.messageType !== 'Text' && x.messageType !== 'Image' ? x.createAt : x.clientArrivalTime,
        ticketId: x.ticketId,
        status: x.status === 1 ? x.status : props.ticketId !== x.ticketId ? 3 : x.status
      }))
      .reverse()
      .filter((x: any) => x.userid !== '');
    // 区分当前单号
    let lastTicketId = props.ticketId;
    let currentInx = 0;
    if (lastTicketId) {
      result.forEach((items: any, index: any) => {
        let currentAgent = agentlist.filter((agent: any) => {
          return items.creator === agent.userId;
        })[0];
        if (currentAgent) {
          items.avatar = currentAgent.avatar;
          items.username = currentAgent.displayName;
        }
        if (items.ticketId && lastTicketId !== items.ticketId) {
          currentInx = index;
        }
      });
    }
    // ticketId

    if (result.length === 0) {
      setLoadText('我也是有底线的');
    } else {
      setLoadText('加载更多历史消息');
    }
    // 插入关单信息
    let newResult = JSON.parse(JSON.stringify(result));
    if (newResult) {
      result.sort(function (a: any, b: any) {
        return moment(a.date).valueOf() - moment(b.date).valueOf();
      });
      result.forEach((item: any) => {
        item.date = moment(item.date).format('YYYY/MM/DD LT');
      });
    }

    let currentMessage = chatMessages.filter((item: any) => {
      return item.id === 'the current message';
    });

    if (currentInx !== 0 && currentMessage.length == 0) {

      result.splice(currentInx + 1, 0, {
        //确保再关单信息之后
        id: 'the current message',
        avatar: props.avatar,
        body: { content: '以下是本次服务信息' },
        userid: '',
        username: '',
        mine: '45C218B5-0CF1-4703-8272-4E863528A1E7',
        date: moment(result[currentInx].date + 1).format('YYYY/MM/DD LT'),
        status: res.status == 0 ? 1 : 0
      });
    }
    (await isReverse) ? setChatMessages((s: any) => [...s, ...result]) : setChatMessages((s: any) => [...result, ...s]);
  };

  useEffect( () => {
    scrollToBottom();
  }, [JSON.stringify(chatMessages)])

  useEffect(() => {
    let Timestamp = moment().format();
    LoadHistoryMessages(Timestamp, 20, true);

    // subscribe to received messages
    pubsub.subscribe(`message-${props.threadId}`, (msg: string, data: any) => {
      const lastMessage = getLastMessage(chatMessagesRef.current);
      const messageContent = JSON.parse(data?.message)?.Content;

      analytics.trackEvent('message_received', {
        threadId: data?.threadId,
        senderDisplayName: data?.senderDisplayName,
        messageId: data?.id,
        messageType: data?.type,
        mine: data?.mine,
        lastMessageMine: lastMessage?.mine,
        lastMessageUserId: lastMessage?.userid,
        secondsSinceLastMessage: getSecondsSinceMessage(lastMessage, data?.date),
        messageContent: messageContent
      });

      clearTimeout(receiveMessage);
      let isAddMessage = true; //是否接受并加载消息到聊天区
      let senderDisplayNameArr = data.senderDisplayName.split(',');
      if (isAddMessage) {
        setChatMessages((s) => {
          let isDuplicateMsg =
            data.id === '45C218B5-0CF1-4703-8272-4E863528A1E7' ? null : s.filter((x: any) => x.id == data.id).length;
          let isDuplicateMsg2 = s.filter((x: any) => x.localId && x.localId == senderDisplayNameArr[3]).length; //如果一个账户多人登录，需要判断消息唯一
          if (isDuplicateMsg || isDuplicateMsg2) {
            return s;
          } else {
            let result = [
              ...s,
              {
                id: data.id,
                avatar:
                  data.senderDisplayName.indexOf('support') !== -1
                    ? senderDisplayNameArr[2] || Component
                    : props.avatar,
                body: JSON.parse(data.message),
                userid: data.sender ? (data.sender as any).communicationUserId : '',
                username: senderDisplayNameArr[1],
                mine:
                  data.senderDisplayName == '45C218B5-0CF1-4703-8272-4E863528A1E7'
                    ? '45C218B5-0CF1-4703-8272-4E863528A1E7'
                    : data.senderDisplayName.indexOf('support') !== -1
                      ? 'support'
                      : '',
                date: moment(data.createdOn).format('YYYY/MM/DD LT'),
                status: 1
              }
            ];
            result.forEach((item: any) => {
              item.date = moment(item.date).valueOf();
            });
            result.sort(function (a: any, b: any) {
              return a.date - b.date;
            });
            result.forEach((item: any) => {
              item.date = moment(item.date).format('YYYY/MM/DD LT');
            });
            return result;
          }
        });
        if (data.senderDisplayName !== 'support') setToBottomTip('有新的未读消息，点击查看');
        scrollToBottom();
      }
    });
  }, [props.threadId]);
  useEffect(() => {
    setUssID('Uid' + uuidv4());
    scrollToBottom();
  }, [props.isScroll]);
  useEffect(() => {
    if (sessionStorage.getItem('user') !== 'undefined') {
      setUserName(JSON.parse(sessionStorage.getItem('user') || '')?.displayName);
      setAvatarUrl(JSON.parse(sessionStorage.getItem('user') || '')?.avatar);
    }
  }, []);

  return (
    <Stack className={chatAreaContainerStyle}>
      {/* //关闭工单 */}
      {isShowbar && (
        <Stack horizontal horizontalAlign="space-between" verticalAlign="center" className={MessageBarStyle}>
          <Stack horizontal verticalAlign="center">
            <Avatar
              image={props.avatar}
              name="游客"
              status={{
                color: 'green',
                icon: <AcceptIcon role='img' aria-label='Online' title='Online' />,
                title: props.user,
                role: 'img',
                'aria-label': 'Online'
              }}
            />
            <Text style={{ 
                marginLeft: '12px', 
                fontSize: '18px', 
                fontWeight: 700,
                textOverflow: 'ellipsis',
                display: 'inline-block',
                overflow: 'hidden',
                whiteSpace: 'nowrap'
              }}>{props.user}</Text>
            <Text 
              title={props.fromUserExtend?.fromPage || '暂无信息'} 
              style={{ 
                marginLeft: '12px', fontSize: '12px',
                textOverflow: 'ellipsis',
                display: 'inline-block',
                width: '180px',
                overflow: 'hidden',
                whiteSpace: 'nowrap'
              }}>
              客户来源：{props.fromUserExtend?.fromPage || '暂无信息'}
            </Text>
          </Stack>

          <Stack horizontal verticalAlign="center">
            <Stack
              horizontal
              verticalAlign="center"
              className={mRightStyle}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                TransferChat();
              }}
            >
              <svg width="106" height="32" viewBox="0 0 106 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M25 18C25 16.8954 24.1046 16 23 16H16C14.8954 16 14 16.8954 14 18V19.5C14 21.5544 16.088 23 19.5 23C19.9587 23 20.3934 22.9739 20.8023 22.9237L20.4393 22.5607C20.2716 22.3929 20.1519 22.1953 20.0802 21.9849C19.8931 21.9949 19.6997 22 19.5 22C16.5786 22 15 20.9071 15 19.5V18C15 17.4477 15.4477 17 16 17H23C23.5523 17 24 17.4477 24 18V18.0854C24.2047 18.1576 24.3969 18.2756 24.5607 18.4393C24.8535 18.7322 24.9999 19.1159 25 19.4997V18ZM30 18.5C30 18.9253 29.935 19.3224 29.8067 19.6854L28.9782 18.8569C28.9928 18.7416 29 18.6225 29 18.5V18C29 17.4477 28.5523 17 28 17L25.829 16.9991C25.6971 16.6265 25.4937 16.2876 25.2353 15.9991L28 16C29.1046 16 30 16.8954 30 18V18.5ZM23 11.5C23 9.567 21.433 8 19.5 8C17.567 8 16 9.567 16 11.5C16 13.433 17.567 15 19.5 15C21.433 15 23 13.433 23 11.5ZM17 11.5C17 10.1193 18.1193 9 19.5 9C20.8807 9 22 10.1193 22 11.5C22 12.8807 20.8807 14 19.5 14C18.1193 14 17 12.8807 17 11.5ZM29 12.5C29 11.1193 27.8807 10 26.5 10C25.1193 10 24 11.1193 24 12.5C24 13.8807 25.1193 15 26.5 15C27.8807 15 29 13.8807 29 12.5ZM25 12.5C25 11.6716 25.6716 11 26.5 11C27.3284 11 28 11.6716 28 12.5C28 13.3284 27.3284 14 26.5 14C25.6716 14 25 13.3284 25 12.5ZM23.1464 23.8536C23.3417 24.0488 23.6583 24.0488 23.8536 23.8536C24.0488 23.6583 24.0488 23.3417 23.8536 23.1464L22.7071 22H28.2929L27.1464 23.1464C26.9512 23.3417 26.9512 23.6583 27.1464 23.8536C27.3417 24.0488 27.6583 24.0488 27.8536 23.8536L29.8536 21.8536C30.0488 21.6583 30.0488 21.3417 29.8536 21.1464L27.8536 19.1464C27.6583 18.9512 27.3417 18.9512 27.1464 19.1464C26.9512 19.3417 26.9512 19.6583 27.1464 19.8536L28.2929 21H22.7071L23.8536 19.8536C24.0488 19.6583 24.0488 19.3417 23.8536 19.1464C23.6583 18.9512 23.3417 18.9512 23.1464 19.1464L21.1464 21.1464C20.9512 21.3417 20.9512 21.6583 21.1464 21.8536L23.1464 23.8536ZM23.2428 21H24.5676H23.2428Z" fill="#242424" />
                <path d="M38.63 11.378V12.358H43.824V11.378H38.63ZM41.402 13.562V22.578H42.41V13.562H41.402ZM38.546 19.176L38.77 20.198C40.296 19.918 42.34 19.498 44.3 19.12L44.244 18.196C42.158 18.574 39.974 18.952 38.546 19.176ZM39.12 16.866C39.12 16.656 39.75 16.306 39.75 16.306V16.292C40.576 14.626 41.416 12.218 41.92 9.964L40.884 9.754C40.562 11.868 39.75 14.22 39.498 14.808C39.246 15.424 39.036 15.872 38.798 15.942C38.924 16.194 39.078 16.656 39.12 16.866ZM39.12 16.866C39.246 16.754 39.666 16.67 40.156 16.67H43.852V15.704H39.694L39.12 15.984V16.866ZM45.868 16.628V17.622H50.054V16.628H45.868ZM49.802 16.628V16.754C49.214 17.636 48.052 19.26 47.086 20.464L47.996 20.884C48.976 19.638 50.11 18.098 50.88 16.936L50.138 16.572L49.984 16.628H49.802ZM45.434 19.68C46.848 20.52 48.514 21.822 49.34 22.648L50.026 21.822C49.2 21.01 47.548 19.834 46.106 19.008L45.434 19.68ZM47.45 9.754C46.862 12.204 45.882 15.634 45.168 17.622H46.302C46.932 15.718 47.856 12.358 48.486 9.894L47.45 9.754ZM44.496 11.392V12.372H50.908V11.392H44.496ZM43.964 14.024V15.004H51.412V14.024H43.964ZM61.016 15.438C59.728 18.98 56.788 20.8 52.546 21.682C52.77 21.934 53.106 22.41 53.218 22.676C57.516 21.598 60.596 19.652 62.136 15.746L61.016 15.438ZM56.452 13.03C55.598 14.22 54.114 15.382 52.742 16.11C53.008 16.306 53.414 16.726 53.596 16.95C54.954 16.096 56.522 14.78 57.516 13.436L56.452 13.03ZM57.012 15.508L56.018 15.816C57.516 19.54 60.33 21.78 64.796 22.634C64.95 22.34 65.258 21.864 65.496 21.626C61.156 20.912 58.314 18.826 57.012 15.508ZM52.854 11.574V12.596H65.146V11.574H52.854ZM58.426 9.726V12.232H59.504V9.726H58.426ZM60.638 13.618C61.982 14.528 63.606 15.886 64.362 16.81L65.272 16.082C64.474 15.158 62.822 13.856 61.506 12.974L60.638 13.618ZM67.456 11.322V12.414H78.6V11.322H67.456ZM66.714 20.506V21.556H79.3V20.506H66.714ZM72.37 11.868V20.94H73.546V11.868H72.37ZM86.412 12.652V22.606H87.504V12.652H86.412ZM83.094 15.396H90.976V16.894H83.094V15.396ZM83.094 13.058H90.976V14.556H83.094V13.058ZM82.072 12.162V17.79H92.054V12.162H82.072ZM80.742 19.12V20.1H93.272V19.12H80.742ZM83.29 10.23C83.85 10.874 84.48 11.784 84.746 12.358L85.684 11.882C85.404 11.308 84.746 10.44 84.186 9.81L83.29 10.23ZM89.926 9.81C89.562 10.594 88.89 11.686 88.372 12.372L89.268 12.722C89.8 12.078 90.5 11.07 91.06 10.174L89.926 9.81Z" fill="#242424" />
              </svg>

            </Stack>
            <Stack
              horizontal
              verticalAlign="center"
              className={mRightStyle}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                closeChat();
              }}
            >
                <svg width="106" height="32" viewBox="0 0 106 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 8C16.8954 8 16 8.89543 16 10V15.207C16.3223 15.1159 16.6566 15.0534 17 15.0224V10C17 9.44772 17.4477 9 18 9H22V12.5C22 13.3284 22.6716 14 23.5 14H27V22C27 22.5523 26.5523 23 26 23H22.4003C22.2174 23.3578 21.9965 23.6929 21.7428 24H26C27.1046 24 28 23.1046 28 22V13.4142C28 13.0164 27.842 12.6349 27.5607 12.3536L23.6464 8.43934C23.3651 8.15804 22.9836 8 22.5858 8H18ZM26.7929 13H23.5C23.2239 13 23 12.7761 23 12.5V9.20711L26.7929 13ZM20.682 23.682C22.4393 21.9246 22.4393 19.0754 20.682 17.318C18.9246 15.5607 16.0754 15.5607 14.318 17.318C12.5607 19.0754 12.5607 21.9246 14.318 23.682C16.0754 25.4393 18.9246 25.4393 20.682 23.682ZM15.732 18.7324C15.9273 18.5371 16.2439 18.5371 16.4391 18.7324L17.4997 19.7929L18.5606 18.732C18.7559 18.5367 19.0725 18.5367 19.2677 18.732C19.463 18.9273 19.463 19.2439 19.2677 19.4391L18.2068 20.5L19.2676 21.5608C19.4628 21.7561 19.4628 22.0727 19.2676 22.2679C19.0723 22.4632 18.7557 22.4632 18.5605 22.2679L17.4997 21.2072L16.4393 22.2675C16.244 22.4628 15.9275 22.4628 15.7322 22.2675C15.5369 22.0723 15.5369 21.7557 15.7322 21.5604L16.7926 20.5L15.732 19.4395C15.5368 19.2442 15.5368 18.9276 15.732 18.7324Z" fill="#242424" />
                  <path d="M40.87 12.904V13.912H49.102V12.904H40.87ZM40.352 16.32V17.314H49.676V16.32H40.352ZM45.504 16.656L44.594 16.852C45.322 19.694 46.778 21.71 49.284 22.62C49.438 22.34 49.746 21.92 49.998 21.696C47.59 20.954 46.148 19.12 45.504 16.656ZM47.576 9.768C47.254 10.552 46.666 11.686 46.204 12.386L47.058 12.736C47.548 12.078 48.164 11.042 48.668 10.146L47.576 9.768ZM41.444 10.342C42.004 11.084 42.606 12.106 42.844 12.778L43.754 12.274C43.502 11.616 42.886 10.622 42.298 9.908L41.444 10.342ZM44.37 13.142V16.054C44.37 17.86 44.09 20.268 39.918 21.85C40.17 22.06 40.492 22.424 40.646 22.676C44.944 20.884 45.462 18.21 45.462 16.054V13.142H44.37ZM55.374 14.346V15.34H62.934V14.346H55.374ZM59.882 12.47V20.086C59.882 20.296 59.798 20.352 59.574 20.366C59.336 20.38 58.566 20.38 57.726 20.352C57.88 20.646 58.034 21.08 58.09 21.374C59.21 21.374 59.924 21.36 60.372 21.178C60.82 21.024 60.96 20.73 60.96 20.1V12.47H59.882ZM53.232 12.904V22.634H54.282V12.904H53.232ZM53.442 10.412C54.1 11.042 54.856 11.91 55.178 12.498L56.046 11.91C55.696 11.322 54.926 10.496 54.254 9.894L53.442 10.412ZM56.97 10.51V11.504H64.334V10.51H56.97ZM63.746 10.51V21.29C63.746 21.5 63.676 21.542 63.48 21.556C63.284 21.57 62.626 21.57 61.968 21.556C62.108 21.808 62.262 22.256 62.318 22.536C63.242 22.536 63.872 22.522 64.264 22.354C64.642 22.172 64.768 21.892 64.768 21.304V10.51H63.746ZM59.574 14.836C58.678 16.558 56.872 18.21 54.744 19.302C54.968 19.47 55.318 19.834 55.472 20.044C57.656 18.854 59.476 17.132 60.54 15.158L59.574 14.836ZM67.456 11.322V12.414H78.6V11.322H67.456ZM66.714 20.506V21.556H79.3V20.506H66.714ZM72.37 11.868V20.94H73.546V11.868H72.37ZM86.412 12.652V22.606H87.504V12.652H86.412ZM83.094 15.396H90.976V16.894H83.094V15.396ZM83.094 13.058H90.976V14.556H83.094V13.058ZM82.072 12.162V17.79H92.054V12.162H82.072ZM80.742 19.12V20.1H93.272V19.12H80.742ZM83.29 10.23C83.85 10.874 84.48 11.784 84.746 12.358L85.684 11.882C85.404 11.308 84.746 10.44 84.186 9.81L83.29 10.23ZM89.926 9.81C89.562 10.594 88.89 11.686 88.372 12.372L89.268 12.722C89.8 12.078 90.5 11.07 91.06 10.174L89.926 9.81Z" fill="#242424" />
                </svg>

            </Stack>
          </Stack>
        </Stack>
      )}

      <Ref innerRef={null}>
        {/* <LiveAnnouncer> */}
        <div ref={createdRef}>
          <div
            style={{
              flex: '1',
              overflow: 'auto', 
              backgroundColor: 'rgb(245, 245, 245)'
            }}
            onScroll={onScrollHandler}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                fontSize: '12px',
                backgroundColor: 'rgb(245, 245, 245)'
              }}
            >
              {' '}
              <a
                style={loadText === '我也是有底线的' ? { color: '#888888' } : { color: '#5B5FC7' }}
                onClick={() => {
                  LoadHistoryMessages(chatMessages[0].date, 20, false);
                }}
              >
                {loadText}
              </a>{' '}
            </div>
            <Chat
              style={{
                background: '#F5F5F5',
                padding: '20px 9%',
                height: 'calc(100vh - 292px)'
              }}
              items={chatMessages.map((message: any, index: number) => {
                if (message.mine === 'CloseTicket' || message.mine === 'TransferTicket') {
                  // // 转交工单聊天卡
                  return {
                    children: (
                      <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                        <div key={index} className={TransferCard}>
                          <span>{message.username}</span> <span style={{ marginLeft: '10px' }}>{message.date} </span>
                          <div
                            style={{
                              display: 'flex',
                              backgroundColor: '#FBFBFB',
                              padding: '16px',
                              borderTop: 'solid 3px #6264A7',
                              overflow: 'hidden'
                            }}
                          >
                            {' '}
                            <div style={{ marginLeft: '14px', flex: '1' }}>
                              <b style={{ marginRight: '14px' }}>
                                {message.mine === 'CloseTicket' ? '工单关闭留言' : '工单转交留言'}
                              </b>
                              <div style={{ marginTop: '14px', whiteSpace: 'pre-line' }}>{message.body}</div>
                              <div style={{ borderTop: 'solid 1px #cccccc' }}>
                              </div>{' '}
                            </div>
                          </div>{' '}
                        </div>
                        <Avatar role='img' aria-label='profile photo' name="转接管理员" image={message.avatar ? message.avatar : Component} />{' '}
                      </div>
                    )
                  };
                } else if (message.mine === '45C218B5-0CF1-4703-8272-4E863528A1E7') {
                  return {

                    children: (
                      <Divider
                        key={index}
                        content={
                          <div>
                            {getExpression(message.body.content)}{' '}
                            {message.body?.msgCode == 1 ? (
                              <a
                                title="非常感谢您的惠顾，后续有什么问题欢迎随时联系线上客服，祝您生活愉快"
                                onClick={() => {
                                  addMessage(0, '非常感谢您的惠顾，后续有什么问题欢迎随时联系线上客服，祝您生活愉快');
                                }}
                              >
                                点击快捷回复
                              </a>
                            ) : (
                              <></>
                            )}
                          </div>
                        }
                        color="#E9E7E6"
                        important
                      />
                    )
                  };
                } else {
                  return {
                    gutter:
                      message.mine === 'support' ? (
                        <Avatar
                          role='img' aria-label='profile photo'
                          name={message.username}
                          image={message.avatar ? message.avatar : Component}
                        />
                      ) : (
                        <Avatar
                          role='img' aria-label='profile photo'
                          name="游客"
                          image={message.avatar && message.avatar}
                          status={{
                            color: 'green',
                            icon: <AcceptIcon />,
                            title: message.username,
                            role: 'img',
                            'aria-label': 'Online'
                          }}
                        />
                      ),
                    key: index,
                    contentPosition: message.mine === 'support' ? 'end' : 'start',
                    message: (
                      <Flex>
                        <Chat.Message
                          styles={{
                            backgroundColor: message.mine === 'support' ? '#E5E5F1' : '#FFFFFF'
                          }}
                          content={
                            <Text style={{ whiteSpace: 'pre-wrap', maxWidth: '60%', boxSizing: 'border-box' }}>
                              {message.body?.MsgType === 0 ? (
                                <span>{getExpression(message.body.Content)}</span>
                              ) : (
                                ''
                              )}
                              {message.body?.MsgType === 1 ? (
                                <Image style={{ maxWidth: '400px' }} src={message.body.Url} 
                                  id={`img-${message?.id}`}
                                  onError={(error: any)=> onImageLoadError(`img-${message?.id}`, message?.body?.Url, error)}
                                  onLoad={() => onImageLoadSuccess(`img-${message?.id}`, message?.body?.Url)}
                                />
                              ) : (
                                ''
                              )}
                            </Text>
                          }
                          author={props.user}
                          mine={message.mine}
                          timestamp={`${message.username || ''} ${message.date}`}
                        />

                        {message.mine === 'support' ? (
                          <div style={{ position: 'relative' }}>
                            {
                              <Icon
                                title={massageState[message.status].title}
                                style={{
                                  cursor: 'pointer',
                                  position: 'absolute',
                                  right: '-5px',
                                  bottom: '-5px',
                                  color: massageState[message.status].color
                                }}
                                iconName={massageState[message.status].Icon}
                                onClick={() => {
                                  ResendMassage(message);
                                }}
                              />
                            }
                          </div>
                        ) : (
                          ''
                        )}
                      </Flex>
                    )
                  };
                }
              })}
            />
            <div
              ref={messagesEnd}
              style={{ width: '100%', height: '52px', backgroundColor: 'rgb(245, 245, 245)' }}
            ></div>
          </div>
        { /* </LiveAnnouncer> */ }
        </div>
      </Ref>

      <div className={boxStyle}>
        <div
          className={scrollToBottomStyles}
          onClick={scrollToBottom}
          style={!isShowToBottomTip ? { display: 'none' } : {}}
        >
          <Icon style={{ marginRight: '6px' }} iconName="Down"></Icon>
          <span> {toBottomTip}</span>
        </div>
        <Stack horizontal={true} className={sendBox}>
          <TextField
            className={textFieldStyle}
            id= {"sendbox" + props.threadId} 
            borderless={true}
            inputClassName={sendBoxStyle}
            placeholder="输入一条新信息"
            value={textValue}
            onChange={setText}
            autoComplete="off"
            componentRef={inputRef}
            resizable={false}
            autoAdjustHeight
            multiline
            onKeyUp={(ev) => {
              if (ev.shiftKey && ev.which === ENTER_KEY && textValueOverflow) {
                setTextValue(textValue);
              } else if (ev.which === ENTER_KEY && textValueOverflow && !ev.shiftKey) {
                textValue.replace(/\s+/g, '') ? addMessage(0, '') : setTextValue(textValue.replace(/\s+/g, ''));
              }
            }}
            styles={TextFieldStyleProps}
            style={{ borderBottom: !textValueOverflow && textValue ? 'solid 3px #C4314B' : 'none' }}
          />
        </Stack>
        <Stack
          horizontal
          style={{ padding: '0px 4% 10px 4%', boxSizing: 'border-box', position: 'relative', zIndex: 5 }}
        >
          <div>

            {!textValueOverflow && textValue && <Text className={PromptText}> 最多{MAXIMUM_LENGTH_OF_MESSAGE}字</Text>}

            <svg
              id={ussID}
              className={inputIcon}
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => handleExpression()}
            >
              <path
                d="M16 8C20.4183 8 24 11.5817 24 16C24 20.4183 20.4183 24 16 24C11.5817 24 8 20.4183 8 16C8 11.5817 11.5817 8 16 8ZM16 9C12.134 9 9 12.134 9 16C9 19.866 12.134 23 16 23C19.866 23 23 19.866 23 16C23 12.134 19.866 9 16 9ZM13.1547 18.4273C14.6642 19.9463 17.0877 20.0045 18.6671 18.5961L18.8453 18.4273C19.04 18.2314 19.3566 18.2304 19.5524 18.4251C19.7265 18.5981 19.7467 18.8674 19.6123 19.0627L19.5547 19.1322L19.5323 19.1545C17.5691 21.1054 14.3962 21.0953 12.4453 19.1322C12.2507 18.9363 12.2517 18.6197 12.4476 18.4251C12.6434 18.2304 12.96 18.2314 13.1547 18.4273ZM18.5 13.5C19.0523 13.5 19.5 13.9477 19.5 14.5C19.5 15.0523 19.0523 15.5 18.5 15.5C17.9477 15.5 17.5 15.0523 17.5 14.5C17.5 13.9477 17.9477 13.5 18.5 13.5ZM13.5 13.5C14.0523 13.5 14.5 13.9477 14.5 14.5C14.5 15.0523 14.0523 15.5 13.5 15.5C12.9477 15.5 12.5 15.0523 12.5 14.5C12.5 13.9477 12.9477 13.5 13.5 13.5Z"
                fill="#242424"
              />
            </svg>

            {showDialog && (
              <TeachingBubble
                target={`#${ussID}`}
                calloutProps={{ directionalHint: DirectionalHint.topCenter }}
                hasCondensedHeadline={true}
                styles={teachingBubbleStyle}
                isWide={false}
                onDismiss={handleExpression}
              >
                <ul className={ExpressionBoxStyle}>
                  {emojiArr.map((v, index) => {
                    return (
                      <li
                        key={index}
                        className={emojiItemStyle}
                        onClick={() => {
                          sendEmoji(v.value);
                          inputRef.current?.focus();
                        }}
                      >
                        {v.value}
                      </li>
                    );
                  })}
                </ul>
              </TeachingBubble>
            )}
          </div>

          <svg
            width="32"
            className={inputIcon}
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={() => sendFiles()}
          >
            <path
              d="M13.5 15C14.0523 15 14.5 14.5523 14.5 14C14.5 13.4477 14.0523 13 13.5 13C12.9477 13 12.5 13.4477 12.5 14C12.5 14.5523 12.9477 15 13.5 15ZM19.5 14C19.5 14.5523 19.0523 15 18.5 15C17.9477 15 17.5 14.5523 17.5 14C17.5 13.4477 17.9477 13 18.5 13C19.0523 13 19.5 13.4477 19.5 14ZM9 12V20C9 21.6569 10.3431 23 12 23H17.3787C17.4056 23 17.4325 22.9995 17.4594 22.9984C17.4728 22.9995 17.4863 23 17.5 23C17.5417 23 17.5822 22.9949 17.6209 22.9853C18.0621 22.9315 18.4754 22.7317 18.7929 22.4142L22.4142 18.7929C22.7317 18.4754 22.9315 18.0621 22.9853 17.6209C22.9949 17.5822 23 17.5417 23 17.5C23 17.4863 22.9995 17.4728 22.9984 17.4594C22.9995 17.4325 23 17.4056 23 17.3787V12C23 10.3431 21.6569 9 20 9H12C10.3431 9 9 10.3431 9 12ZM22 12V17H19.75C18.5409 17 17.514 17.7803 17.1455 18.8649C16.8126 18.949 16.4337 19 16.0019 19C15.0872 19 14.4128 18.7722 13.9738 18.5527C13.7534 18.4426 13.5913 18.334 13.4875 18.2562C13.4356 18.2173 13.3985 18.1862 13.3761 18.1667C13.3649 18.1569 13.3574 18.15 13.3537 18.1465L13.351 18.1439C13.1556 17.9512 12.8409 17.952 12.6464 18.1464C12.4512 18.3417 12.4512 18.6583 12.6464 18.8536L12.6472 18.8543L12.648 18.8551L12.65 18.8571L12.655 18.862L12.6698 18.876C12.6816 18.8871 12.6976 18.9017 12.7176 18.9193C12.7578 18.9544 12.8144 19.0014 12.8876 19.0563C13.0339 19.166 13.2468 19.3074 13.5267 19.4473C14.0881 19.7278 14.9146 20 16.0019 20C16.3628 20 16.6948 19.9699 17 19.9173V22H12C10.8954 22 10 21.1046 10 20V12C10 10.8954 10.8954 10 12 10H20C21.1046 10 22 10.8954 22 12ZM18.0858 21.7071C18.0585 21.7344 18.0299 21.7599 18 21.7836V19.75C18 18.7835 18.7835 18 19.75 18H21.7836C21.7599 18.0299 21.7343 18.0585 21.7071 18.0858L18.0858 21.7071Z"
              fill="#212121"
            />
          </svg>
          <svg
            className={sendIconStyle}
            onClick={() => {
              if (textValueOverflow) {
                textValue.replace(/\s+/g, '') ? addMessage(0, '') : setTextValue(textValue.replace(/\s+/g, ''));
              }
            }}
            id="sendmessage"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.72113 8.05149L24.0756 15.6175C24.3233 15.7395 24.4252 16.0393 24.3031 16.287C24.2544 16.3858 24.1744 16.4658 24.0756 16.5145L8.72144 24.0803C8.47374 24.2023 8.17399 24.1005 8.05193 23.8528C7.99856 23.7445 7.98619 23.6205 8.0171 23.5038L9.9858 16.0701L8.01676 8.62789C7.94612 8.36093 8.10528 8.08726 8.37224 8.01663C8.48893 7.98576 8.61285 7.99814 8.72113 8.05149ZM9.26445 9.43403L10.8736 15.5161L10.9355 15.5041L11 15.5H18C18.2761 15.5 18.5 15.7239 18.5 16C18.5 16.2455 18.3231 16.4496 18.0899 16.4919L18 16.5H11C10.9686 16.5 10.9379 16.4971 10.9081 16.4916L9.26508 22.6976L22.7234 16.066L9.26445 9.43403Z"
              fill="#242424"
            />
          </svg>


        </Stack>
      </div>
      {HintDialogTitle && HintDialogSubText && (
        <Dialog
          hidden={hideDialog}
          type={DialogType.normal}
          title={HintDialogTitle}
          subText={HintDialogSubText}
          onDismiss={() => {
            setIsDraggable(false);
          }}
          modalProps={modalProps}
        >
          <DialogFooter>
            <PrimaryButton
              style={{ background: '#5B5FC7' }}
              onClick={() => {
                hideDialogPrimary();
              }}
              text="确定"
            />
          </DialogFooter>
        </Dialog>
      )}

      <CloseListDialog
        toggle={closeDialogToggle}
        initial={closeDialogInitial}
        EndComment={EndComment}
        displayTicketId={props.displayTicketId}
      />
      <TransferListDialog
        toggle={transferDialogToggle}
        initial={transferDialogInitial}
        isFromMonitor={props.isInvolved}
        closeComment={closeComment}
        displayTicketId={props.displayTicketId}
      />
    </Stack>
  );
};
